// @ts-nocheck
/* eslint-disable */
import { store } from '~/state/store';
import Content from './content';
import { firmStats } from "~/util/review";
import { CONFIG } from '~/config';

/**
 * @class HotelGallery
 * @augments SMap.Detail.Content
 * @private
 */
 export default class HotelGallery extends Content {
	_build() {
		this._dom.container.classList.add("content-hotelgallery");

		var galleryData = this._data.filter(function(i) { return !i.best; })

		// galerie
		if (galleryData.length >= 3) {
			var bookGallery = Mapy.Util.node("a", { className: "mini-gallery", href: "https://" + CONFIG.BASE_URL + "/?source=" + this._options.source + "&id=" + this._options.id + "&gallery=1" });
			bookGallery.addEventListener("click", function(e) {
				e.preventDefault();

				const { data: detailData } = store.getState().detail;

				firmStats("firmy-vizitka-akce", detailData, { typeId: 17 });
				Mapy.getComponent("detail").openGallery();
			});
			galleryData.forEach(function(i, ind) {
				if (ind >= 3) return;

				var imgCover = Mapy.Util.node("span", { className: "cover" });
				var img = new Image();
				img.crossOrigin = "anonymous";
				img.classList.add("landscape");
				img.addEventListener("load", function() {
					var pW = imgCover.offsetWidth;
					var pH = imgCover.offsetHeight;
					var w = img.naturalWidth;
					var h = img.naturalHeight;
					// spocitame novou sirku
					var cW = pH * w / h;

					if (cW < pW) {
						img.classList.remove("landscape");
						img.classList.add("portrait");
					}
				});
				img.src = Mapy.CDN.setSize(i.urls["16x9"], Mapy.CDN.SIZE_160_104);
				imgCover.appendChild(img);
				bookGallery.appendChild(imgCover);
			});
			this._dom.container.appendChild(bookGallery);
		}
	}
};
